
<mat-card appearance="outlined">
  <mat-card-title class="d-flex justify-content-start align-items-center">
    <h3 class="m-0 bottin" style="flex: 0 0 90%; max-width: 90%">{{'memberPublicInfos.memberInfos' | translate}}</h3>
    <div style="flex: 1 1 0%">
      <button  mat-button (click)="printMemberInfos()">
        {{'memberPublicInfos.print' | translate}}
        <mat-icon iconPositionEnd>print</mat-icon>
      </button>

    </div>
  </mat-card-title>
  <mat-divider></mat-divider>
  <mat-card-content >
    <div
      class="mt-8 p-8 d-flex flex-wrap" style="gap: 8px">

      <odq-label-value style="flex: 0 0 calc(50% - 8px); max-width: calc(50% - 8px)">
        <odq-label >{{ 'memberPublicInfos.name' | translate }}</odq-label>
        <odq-value >{{ memberPublicInfos?.firstName }} {{ memberPublicInfos?.lastName }}</odq-value>
      </odq-label-value>

      <odq-label-value style="flex: 0 0 calc(50% - 8px); max-width: calc(50% - 8px)">
        <odq-label >{{ 'memberPublicInfos.permitNumber' | translate }}</odq-label>
        <odq-value >{{ memberPublicInfos?.permitNumber  }}</odq-value>
      </odq-label-value>
      <odq-label-value style="width: 100%; height: 100%">
        <odq-label>{{ 'memberPublicInfos.permitType' | translate }}</odq-label>
        <odq-value [innerHtml]="memberPublicInfos?.permitType | localized"></odq-value>
      </odq-label-value>
      @if (!isRegistered()) {
        <odq-label-value style="flex: 0 0 calc(50% - 8px); max-width: calc(50% - 8px)">
          <odq-label>{{ 'memberPublicInfos.effectiveInscriptionStatus.label' | translate }}</odq-label>
          <odq-value>{{ 'memberPublicInfos.effectiveInscriptionStatus.' +  memberPublicInfos?.effectiveInscriptionStatus | translate  }}</odq-value>
        </odq-label-value>
      }
      @if (isRegistered()) {
        <odq-label-value style="flex: 0 0 calc(50% - 8px); max-width: calc(50% - 8px)">
          <odq-label>{{ 'memberPublicInfos.effectiveInscriptionStatus.label' | translate }}</odq-label>
          <odq-value>{{ 'memberPublicInfos.effectiveInscriptionStatus.' +  memberPublicInfos?.effectiveInscriptionStatus | translate  }} - {{ isPermitSuspended() ? 'Permis suspendu' : ('memberPublicInfos.effectiveExerciseStatus.' + memberPublicInfos?.effectiveExerciseStatus | translate) }}  {{ !isActive() ? inactivityDate()  : ''}} {{ !isPermitSuspended() && memberPublicInfos.limitations?.length > 0 ? ('memberPublicInfos.effectiveExerciseStatus.limitedPractice' | translate) : '' }}</odq-value>
        </odq-label-value>
      }
      @if (isNotAuthorized) {
        <odq-label class="notAuthorized" style="width: 100%; height: 100%">{{ 'memberPublicInfos.notAuthorizedMember' | translate}}</odq-label>
      }
      <odq-label-value style="width: 100%; height: 100%">
        <odq-label>{{ 'memberPublicInfos.assurance.label' | translate }}</odq-label>
        <odq-value>{{ getInsuranceStatus() }}</odq-value>
      </odq-label-value>

      @if (isRegistered()) {
        <odq-label-value style="width: 100%; height: 100%">
          <odq-label>{{ 'memberPublicInfos.disciplinaryBoard.label' | translate }}</odq-label>
          @if (memberPublicInfos?.decisions.length > 0) {
            <odq-value>
              {{ 'memberPublicInfos.disciplinaryBoard.atLeastOneFile' | translate }}
            </odq-value>
          }
          @if (memberPublicInfos?.decisions.length == 0) {
            <odq-value>
              {{ 'memberPublicInfos.disciplinaryBoard.none' | translate }}
            </odq-value>
          }
        </odq-label-value>
      }

      @if (!!memberPublicInfos?.professionalDomicile?.clinicName && isRegistered()) {
        <odq-label-value style="width: 100%; height: 100%">
          <odq-label>{{ 'memberPublicInfos.professionalDomicile.clinicName' | translate }}</odq-label>
          <odq-value>{{ memberPublicInfos?.professionalDomicile?.clinicName }}</odq-value>
        </odq-label-value>
      }

      @if (!isActive()) {
        <odq-label-value style="width: 100%; height: 100%">
          <odq-label>{{ 'memberPublicInfos.professionalDomicile.address' | translate }}</odq-label>
          <odq-value>{{ memberPublicInfos?.professionalDomicile?.address.city }}</odq-value>
        </odq-label-value>
      }


      @if (!!memberPublicInfos?.professionalDomicile?.phone) {
        <odq-label-value style="flex: 0 0 calc(50% - 8px); max-width: calc(50% - 8px)">
          <odq-label>{{ 'memberPublicInfos.professionalDomicile.phone' | translate }}</odq-label>
          <odq-value>{{ memberPublicInfos?.professionalDomicile?.phone | phoneNumber }}</odq-value>
        </odq-label-value>
      }

      @if (!!memberPublicInfos?.professionalDomicile?.fax) {
        <odq-label-value style="flex: 0 0 calc(50% - 8px); max-width: calc(50% - 8px)">
          <odq-label>{{ 'memberPublicInfos.professionalDomicile.fax' | translate }}</odq-label>
          <odq-value>{{ memberPublicInfos?.professionalDomicile?.fax | phoneNumber }}</odq-value>
        </odq-label-value>
      }

      @if ( memberPublicInfos?.professionalDomicile?.wheelchairAccess) {
        <odq-label-value style="flex: 0 0 calc(50% - 8px); max-width: calc(50% - 8px)">
          <odq-label>{{ 'memberPublicInfos.professionalDomicile.wheelchairAccess' | translate }}</odq-label>
          <odq-value>{{ memberPublicInfos?.professionalDomicile?.wheelchairAccess | yesNo }}</odq-value>
        </odq-label-value>
      }

      @if (memberPublicInfos?.specialtiTypeIds.length> 0) {
        <odq-label-value style="width: 100%; height: 100%">
          <odq-label>{{ 'memberPublicInfos.specialties' | translate }}</odq-label>
          @for (specTypeId of memberPublicInfos.specialtiTypeIds; track specTypeId) {
            <odq-value>
              {{getSpecialtyTypeLabelForId(specTypeId) }}
            </odq-value>
          }
          <br>
          </odq-label-value>
        }
      </div>
    </mat-card-content>
  </mat-card>

  @if ( memberPublicInfos?.limitations?.length > 0) {
    <mat-card appearance="outlined">
      <mat-card-title class="d-flex justify-content-start align-items-center">
        <h3 class="m-0 bottin">{{'memberPublicInfos.limitation.label' | translate}}</h3>
      </mat-card-title>
      <mat-divider></mat-divider>
      <mat-card-content>
        @for (limitation of getSortedLimitations(); track limitation) {
          <div
            class="mt-8 p-8 d-flex flex-wrap" style="gap: 8px">
            <odq-label-value style="flex: 0 0 calc(50% - 8px); max-width: calc(50% - 8px)">
              <odq-label>{{ 'memberPublicInfos.limitation.startDate' | translate }}</odq-label>
              <odq-value>{{ limitation?.startAt  | date: 'mediumDate': '' : translate.currentLang }}</odq-value>
            </odq-label-value>
            <odq-label-value style="flex: 0 0 calc(50% - 8px); max-width: calc(50% - 8px)">
              <odq-label>{{ 'memberPublicInfos.limitation.endDate' | translate }}</odq-label>
              <odq-value>{{ limitation?.endAt  | date: 'mediumDate': '' : translate.currentLang }}</odq-value>
            </odq-label-value>
            <odq-label-value style="flex: 1 1 0%">
              <odq-value [innerHtml]="limitation?.description | localized | sanitizeHtml"></odq-value>
            </odq-label-value>
            <mat-divider [inset]="true"></mat-divider>
            <br>
            </div>
          }
        </mat-card-content>
      </mat-card>
    }

    @if (isRegistered() && ( memberPublicInfos?.firstInscriptionDate || memberPublicInfos?.specialities?.length > 0)) {
      <mat-card appearance="outlined">
        <mat-card-title class="d-flex justify-content-start align-items-center">
          <h3 class="m-0 bottin">{{'memberPublicInfos.memberHistory.label' | translate}}</h3>
        </mat-card-title>
        <mat-divider></mat-divider>
        <mat-card-content>
          @if (memberPublicInfos?.firstInscriptionDate) {
            <odq-label-value style="width: 100%; height: 100%">
              <odq-label>{{ 'memberPublicInfos.memberHistory.firstInscriptionDate' | translate}}</odq-label>
              <odq-value [innerHtml]="memberPublicInfos?.firstInscriptionDate | date: 'mediumDate': '' : translate.currentLang ">
              </odq-value>
            </odq-label-value>
          }
          @if (memberPublicInfos?.specialities?.length > 0) {
            <div>
              <div class="secondary-text mat-caption odq-label">{{ 'memberPublicInfos.specialitiesDate' | translate}}</div>
              @for (specialty of memberPublicInfos?.specialities; track specialty) {
                <div>
                  <div>
                    <span>{{specialty?.description | localized}} - {{ specialty?.obtainedDate | date: 'mediumDate': '' : translate.currentLang }}</span>
                  </div>
                </div>
              }
            </div>
          }
        </mat-card-content>
      </mat-card>
    }

    @if (showMemberSpecification()) {
      <mat-card appearance="outlined" style="width: 100%; height: 100%">
        <mat-card-title class="d-flex justify-content-start align-items-center">
          <h3 class="m-0 bottin">{{'memberPublicInfos.memberSpecification' | translate}}</h3>
        </mat-card-title>
        <mat-divider></mat-divider>
        <mat-card-content>
          <div
            class="mt-8 p-8 d-flex flex-wrap" style="gap: 8px">
            @if (memberPublicInfos?.isAnesthesiaPrivateClinic) {
              <odq-label-value style="flex: 0 0 calc(50% - 8px); max-width: calc(50% - 8px)">
                <odq-label>{{ 'memberPublicInfos.isAnesthesiaPrivateClinic' | translate }}</odq-label>
                <odq-value>{{ memberPublicInfos?.isAnesthesiaPrivateClinic | yesNo }}</odq-value>
              </odq-label-value>
            }
            @if (memberPublicInfos?.isAnesthesiaHospital) {
              <odq-label-value style="flex: 0 0 calc(50% - 8px); max-width: calc(50% - 8px)">
                <odq-label>{{ 'memberPublicInfos.isAnesthesiaHospital' | translate }}</odq-label>
                <odq-value>{{ memberPublicInfos?.isAnesthesiaHospital | yesNo }}</odq-value>
              </odq-label-value>
            }
            @if (memberPublicInfos?.isParticularMedicalCondition) {
              <odq-label-value style="flex: 0 0 calc(50% - 8px); max-width: calc(50% - 8px)">
                <odq-label>{{ 'memberPublicInfos.isParticularMedicalCondition' | translate }}</odq-label>
                <odq-value>{{ memberPublicInfos?.isParticularMedicalCondition | yesNo }}</odq-value>
              </odq-label-value>
            }
            @if (memberPublicInfos?.isHomeVisit) {
              <odq-label-value style="flex: 0 0 calc(50% - 8px); max-width: calc(50% - 8px)">
                <odq-label>{{ 'memberPublicInfos.isHomeVisit' | translate }}</odq-label>
                <odq-value>{{ memberPublicInfos?.isHomeVisit | yesNo }}</odq-value>
              </odq-label-value>
            }
            @if (memberPublicInfos?.isSleepApnea) {
              <odq-label-value style="flex: 0 0 calc(50% - 8px); max-width: calc(50% - 8px)">
                <odq-label>{{ 'memberPublicInfos.isSleepApnea' | translate }}</odq-label>
                <odq-value>{{ memberPublicInfos?.isSleepApnea | yesNo }}</odq-value>
              </odq-label-value>
            }
            @if (memberPublicInfos?.isReducedMobility) {
              <odq-label-value style="flex: 0 0 calc(50% - 8px); max-width: calc(50% - 8px)">
                <odq-label>{{ 'memberPublicInfos.isReducedMobility' | translate }}</odq-label>
                <odq-value>{{ memberPublicInfos?.isReducedMobility | yesNo }}</odq-value>
              </odq-label-value>
            }
            @if (memberPublicInfos?.isLiftPerson) {
              <odq-label-value style="flex: 0 0 calc(50% - 8px); max-width: calc(50% - 8px)">
                <odq-label>{{ 'memberPublicInfos.isLiftPerson' | translate }}</odq-label>
                <odq-value>{{ memberPublicInfos?.isLiftPerson | yesNo }}</odq-value>
              </odq-label-value>
            }
          </div>
        </mat-card-content>
      </mat-card>
    }

    @if (isActive() && memberPublicInfos?.activeWorkAddresses?.length > 0) {
      <mat-card appearance="outlined">
        <mat-card-title class="d-flex justify-content-start align-items-center">
          <h3 class="m-0 bottin">{{'memberPublicInfos.workAddress.label' | translate}}</h3>
        </mat-card-title>
        <mat-divider></mat-divider>
        <mat-card-content>
          @for (workAddress of memberPublicInfos?.activeWorkAddresses; track workAddress; let i = $index) {
            <div class="d-flex flex-wrap"
              >
              @if (!!workAddress?.clinicName) {
                <odq-label-value style="width: 100%; height: 100%">
                  <odq-label>{{ 'memberPublicInfos.professionalDomicile.clinicName' | translate }}</odq-label>
                  <odq-value>{{ workAddress?.clinicName }}</odq-value>
                </odq-label-value>
              }
              @if (i == 0) {
                <div
                  class="principal-label"
                  >
                  {{ 'memberPublicInfos.professionalDomicile.principal' | translate }}
                </div>
              }
              <odq-address-displayer
                [address]="workAddress?.address"
                [addressLabel]="'memberPublicInfos.professionalDomicile.address' | translate"
                [cityLabel]="'memberPublicInfos.professionalDomicile.city' | translate"
                [showPostalCode]="true" style="width: 100%; height: 100%">
              </odq-address-displayer>
              @if (!!workAddress?.phone) {
                <odq-label-value style="flex: 0 0 calc(50% - 8px); max-width: calc(50% - 8px)">
                  <odq-label>{{ 'memberPublicInfos.professionalDomicile.phone' | translate }}</odq-label>
                  <odq-value>{{ workAddress?.phone | phoneNumber }}</odq-value>
                </odq-label-value>
              }
              @if (!!workAddress?.fax) {
                <odq-label-value style="flex: 0 0 calc(50% - 8px); max-width: calc(50% - 8px)">
                  <odq-label>{{ 'memberPublicInfos.professionalDomicile.fax' | translate }}</odq-label>
                  <odq-value>{{ workAddress?.fax | phoneNumber }}</odq-value>
                </odq-label-value>
              }
              @if (workAddress.isWheelchairAccessible) {
                <div style="width: 100%; height: 100%">
                  <span>{{'memberPublicInfos.accessible' | translate}}</span>
                  <mat-icon>accessible_forward</mat-icon>
                </div>
              }
              <mat-divider [inset]="true"></mat-divider>
              <br>
              </div>
            }
          </mat-card-content>
        </mat-card>
      }


      @if (memberPublicInfos?.decisions?.length > 0) {
        <mat-card appearance="outlined">
          <mat-card-title class="d-flex justify-content-start align-items-center">
            <h3 class="m-0 bottin">{{'memberPublicInfos.disciplinaryBoard.label' | translate}}</h3>
          </mat-card-title>
          <mat-divider></mat-divider>
          <mat-card-content>
            @for (mp of getSortedDecisions(); track mp) {
              <div
                class="mt-8 p-8 d-flex flex-wrap"
                style="gap: 8px">
                <odq-label-value style="flex: 0 0 calc(50% - 8px); max-width: calc(50% - 8px)">
                  <odq-label>{{ 'memberPublicInfos.disciplinaryBoard.recordNumber' | translate }}</odq-label>
                  <odq-value>{{convertRecordNumber(mp?.recordNumber)}}</odq-value>
                </odq-label-value>
                <odq-label-value style="flex: 0 0 calc(50% - 8px); max-width: calc(50% - 8px)">
                  <odq-label>{{ 'memberPublicInfos.disciplinaryBoard.date' | translate }}</odq-label>
                  <odq-value>{{mp?.decisionDate | date:'mediumDate'}}</odq-value>
                </odq-label-value>
                <odq-label-value style="flex: 0 0 calc(50% - 8px); max-width: calc(50% - 8px)">
                  <odq-label>{{ 'memberPublicInfos.disciplinaryBoard.publicDecisionType' | translate }}</odq-label>
                  <odq-value>{{mp?.publicDecisionType | localized}}</odq-value>
                </odq-label-value>
                <div style="flex: 0 0 calc(50% - 8px); max-width: calc(50% - 8px)">
                  <div class="secondary-text mat-caption odq-label">{{ 'memberPublicInfos.disciplinaryBoard.documents' | translate }}</div>
                  @for (item of mp?.documents; track item) {
                    <div>
                      <div>
                        <a href="javascript:undefined"
                        (click)="downloadDocument(item)">{{item.documentName}}</a>
                      </div>
                    </div>
                  }
                </div>
                <mat-divider [inset]="true"></mat-divider>
                <br>
                </div>
              }
            </mat-card-content>
          </mat-card>
        }
        <div class="mb-2 bottin">{{'memberPublicInfos.inDateOf' | translate}} {{ today | date: 'mediumDate': '' : translate.currentLang }}</div>
